<template src="./facial_verification_field.html"></template>

<script>
import { defineComponent } from 'vue';
import { createFacialVerificationFieldState } from './facial_verification_field_state';

export default defineComponent({
  name: 'FacialVerificationField',
  props: {
    applicationFormId: {
      type: Number,
      default: null
    },
    question: {
      type: Object,
      required: true
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    return createFacialVerificationFieldState(props, emit);
  }
});
</script>
<style scoped src="./facial_verification_field_base.css"></style>
<style scoped src="./facial_verification_field_layout.css"></style>
